var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenamedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#FFE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.200195C18.517 0.200195 23.7998 5.48304 23.7998 12C23.7998 18.517 18.517 23.7998 12 23.7998C5.48304 23.7998 0.200195 18.517 0.200195 12C0.200195 5.48304 5.48304 0.200195 12 0.200195Z",
    stroke: "#FFCBE4",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 15.9999H16.8999M13.8999 8.49988L15.3999 9.99988M14.5879 7.81087C14.7869 7.61182 15.0569 7.5 15.3384 7.5C15.6199 7.5 15.8898 7.61182 16.0889 7.81087C16.2879 8.00991 16.3998 8.27988 16.3998 8.56137C16.3998 8.84286 16.2879 9.11282 16.0889 9.31187L10.0839 15.3174C9.96494 15.4363 9.8179 15.5233 9.65639 15.5704L8.22039 15.9894C8.17737 16.0019 8.13176 16.0027 8.08835 15.9915C8.04493 15.9804 8.0053 15.9578 7.97361 15.9261C7.94192 15.8945 7.91933 15.8548 7.90821 15.8114C7.89709 15.768 7.89784 15.7224 7.91039 15.6794L8.32939 14.2434C8.3765 14.082 8.46351 13.9352 8.58239 13.8164L14.5879 7.81087Z",
    stroke: "#C1005D",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30684",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.999911 0 0 0 0 0.633878 0 0 0 0 0.809574 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30684"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenamedIcon);
export default __webpack_public_path__ + "static/media/renamed_icon.b00d53a44cea4a885924dc056cf91603.svg";
export { ForwardRef as ReactComponent };